import type { ReactNode } from 'react';
import { Card } from '@/components/ui';

/** Shared frame for the signed out screens. */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-4 py-10">
      <div className="mb-8">
        <p className="text-3xl font-bold text-primary">Chipn</p>
        <p className="mt-2 text-text-muted">Save and contribute toward goals, together.</p>
      </div>
      <Card className="p-5">{children}</Card>
    </main>
  );
}

export function FormError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <p role="alert" className="text-sm text-danger">
      {message}
    </p>
  );
}
